import { combineReducers } from 'redux';

import errorMessage from './errorMessage/reducer';

export default combineReducers({
    errorMessage,
});